import React, { useEffect, useState } from 'react';
import './index.css';
import { useNavigate } from 'react-router-dom';
import { query, collection, onSnapshot, orderBy } from "firebase/firestore";
import { db } from '../../../../firebase';
import noDataFound from '../../../../assets/images/icons/no-data-found.png';
import { toast } from 'react-toastify';
import { useAuth } from '../../../../context/AuthContext';
import TotalCount from '../../../datatables/properties/total-unit-count';
import TotalBookedUnitCount from '../../../datatables/properties/total-booked-count';

const PropertyWidget = () => {

  const navigate = useNavigate();

  const { user } = useAuth();
  const { bid } = user.claims;

  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState(null);

  useEffect(() => {
    const q = query(collection(db, "Businesses", bid, "Properties"), orderBy('updatedOn'));
    const unsubscribe = onSnapshot(q, (querySnapshot) => {
      const tempData = [];
      querySnapshot.forEach((doc) => {
        tempData.push({ id: doc.id, ...doc.data() });
      });

      setData(tempData);
      setIsLoading(false);
    }, (error) => {
      console.log(error.message);
      toast.error(error.message);
      setIsLoading(false);
    });

    return () => unsubscribe;
  }, []);

  return (
    <div className='datatable'>
      <table className='table'>
        {
          data && data.length > 0 ?
            <>
              <thead className='table-head sticky-top'>
                <tr>
                  <th className='text-start'>Property Name</th>
                  <th className='text-start text-center'>Total Unit</th>
                  <th className='text-start text-center'>Booked</th>
                </tr>
              </thead>
              <tbody>
                {
                  data && data.map((tb_items, index) => {
                    let totalUnit = 0;
                    let totalBooking = 0;

                    return (
                      <tr key={index}>
                        <td
                          className="align-middle cursor-pointer text-primary"
                          onClick={() => navigate('/admin/properties/details', { state: { items: tb_items } })}
                        >
                          {tb_items.name}
                        </td>
                        <td className="align-middle text-center">
                          <TotalCount propID={tb_items.id} />
                        </td>
                        <td className="align-middle text-center">
                          <TotalBookedUnitCount propID={tb_items.id} />
                        </td>
                      </tr>
                    )
                  })
                }
              </tbody>
            </>
            :
            <tbody>
              <tr className='no-data-found bg-white'>
                <td className='text-center bg-primary-light rounded w-100 m-3' colSpan={4}>
                  <img src={noDataFound} alt="no-data-found" className='img-fluid' />
                  <span>No Properties Found</span>
                </td>
              </tr>
            </tbody>
        }
      </table>
    </div>
  );
}

export default PropertyWidget;
